// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"31dd1217","201":"2a1ec7d0","524":"239982e9","549":"63370f00","990":"64c60ef0"}[chunkId] + ".chunk.css";
};